import React, { useEffect, useState } from "react";
import { Card, Row, Col, Form, Button } from "react-bootstrap";
import * as Icons from "react-feather";
import Center from "react-center";
import moment from "moment";
import bwipjs from "bwip-js";
import ReactToPdf from "react-to-pdf";
import { useParams } from "react-router-dom";
import Axios from "axios";
import { urlAPI } from "Common";
import FailedAlert from "view/component/FailedAlert";

const initData = {
  nobooking: "",
  namapasien: "",
  norm: "",
  noantrian: 0,
  tanggal: null,
  jam: null,
  namasbu: "",
  namaunit: "",
  namadokter: "",
  jaminan: "",
  pasienbaru: false,
  sesi: "",
};
export default function IndexOnsite(props) {
  const ref = React.createRef();
  const { nobooking } = useParams();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(initData);
  const [messageState, setMessageState] = useState("");
  const [showFailed, setShowFailed] = useState(false);

  //console.log("data: ", data);

  const fetchData = () => {
    Axios.get(urlAPI + "/public/ticket/data?nobooking=" + nobooking)
      .then((response) => {
        if (response?.data?.result?.length > 0) {
        //  console.log("response: ", response?.data?.result[0]);
          setData({ ...response?.data?.result[0] });
          setLoading(false);
        } else {
          setData(initData);
          setLoading(false);
        }
      })
      .catch((err) => {
        setMessageState(err?.response?.data?.message ?? err?.response);
        setShowFailed(true);
        setLoading(false);
      });
  };

  useEffect(() => {
    setLoading(true);
    fetchData();
  }, []);

  useEffect(() => {
    if (data?.nobooking) {
      let canvas = bwipjs.toCanvas("checkin", {
        bcid: "azteccode", // Barcode type
        text: data?.nobooking, // Text to encode
        scale: 3, // 3x scaling factor
        textxalign: "center", // Always good to set this
      });
    }
  }, [data]);

  const options = {
    orientation: "landscape",
    // unit: "in",
    // format: [4, 2],
    unit: "mm",
    format: [210, 297],
  };

  return (
    <>
      <FailedAlert
        show={showFailed}
        message={messageState}
        onConfirm={() => {
          setMessageState("");
          setShowFailed(false);
        }}
      />
      {!nobooking ? (
        <div style={{ textAlign: "center" }}>
          <h1>
            <strong>Terjadi Kesalahan, No Booking Tidak Ada.</strong>
          </h1>
        </div>
      ) : (
        <>
          {loading && (
            <div style={{ textAlign: "center" }}>
              <h1>
                <strong>Sedang Mencari Data, Mohon Tunggu...</strong>
              </h1>
              <br />
            </div>
          )}

          <>
            <div
              ref={ref}
              style={{
                margin: "auto",
                maxWidth: "420px",
                padding: "10px",
              }}
            >
              <div style={{ textAlign: "center"}}>
                <h3>
                  <div style={{color : "black"}}> <strong>Registrasi Online Berhasil</strong> </div>
                </h3>
                <br />
                <canvas id="checkin"></canvas>
                <br />
                <br />
                <h5>Nomor Booking: {data?.nobooking}</h5>
                <h6>Nomor Antrian: {data?.noantrian}</h6>
                <h6>
                  {moment(data?.tanggal).format("DD/MM/YYYY") +
                    " | " +
                    data?.jam}
                </h6>

                <h6>Sesi: {data?.sesi}</h6>
              </div>
              <br />
              <Card>
                <Card.Body>
                  <Row>
                    <Col lg="12" md="12" sm="12">
                      <Form.Group className="mb-3">
                        <Form.Label>Nama Pasien</Form.Label>
                        <Form.Control
                          name="nama"
                          id="nama"
                          type="text"
                          value={data?.namapasien}
                          disabled={true}
                        />
                      </Form.Group>
                    </Col>
                    <Col lg="12" md="12" sm="12">
                      <Form.Group className="mb-3">
                        <Form.Label>No RM / Rekam Medis</Form.Label>
                        <Form.Control
                          name="norm"
                          id="norm"
                          type="text"
                          value={data?.norm}
                          disabled={true}
                        />
                      </Form.Group>
                    </Col>
                    <Col lg="12" md="12" sm="12">
                      <Form.Group className="mb-3">
                        <Form.Label>Tujuan</Form.Label>
                        <Form.Control
                          name="tujuan"
                          id="tujuan"
                          type="text"
                          value={data?.namasbu}
                          disabled={true}
                        />
                      </Form.Group>
                    </Col>
                    <Col lg="12" md="12" sm="12">
                      <Form.Group className="mb-3">
                        <Form.Label>Unit</Form.Label>
                        <Form.Control
                          name="unit"
                          id="unit"
                          type="text"
                          value={data?.namaunit}
                          disabled={true}
                        />
                      </Form.Group>
                    </Col>
                    <Col lg="12" md="12" sm="12">
                      <Form.Group className="mb-3">
                        <Form.Label>Dokter</Form.Label>
                        <Form.Control
                          name="tujuan"
                          id="tujuan"
                          type="text"
                          value={data?.namadokter}
                          disabled={true}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>

              <span style={{ color: "#F57F17" }}>
                <strong>
                  * Mohon Screenshot / Simpan tampilan ini agar memudahkan Klaim
                  Registrasi Online Anda.
                </strong>
                {data?.jaminan === "umum" && (
                  <>
                    <br />
                    <strong>
                      * Untuk pasien Umum harap menyelesaikan Pembayaran
                      Administrasi Pendaftaran di Kasir.
                    </strong>
                  </>
                )}

                {parseInt(data.pasienbaru) === 1 && (
                  <>
                    <br />
                    <strong>
                      * Mohon Menuju Lobi Pendaftaran minimal satu jam sebelum
                      Antrian Poli, untuk melengkapi data rekam medis pasien
                      baru dengan membawa KTP pasien.
                    </strong>
                  </>
                )}
                {(parseInt(data?.ramayanaNonPG) === 1 ||
                  data?.jaminan === "bpjs") && (
                  <>
                    <br />
                    <strong>
                      * Harap ke Lobby untuk melakukan pengecekan Administrasi.
                    </strong>
                  </>
                )}
                {data?.jaminan === "lain" && (
                  <>
                    <br />
                    <strong>
                      * Mohon ke lobby pendaftaran untuk melakukan verifikasi
                      administrasi.
                    </strong>
                  </>
                )}
                {data?.namasbu === "Rumah Sakit Petrokimia Gresik" && (
                  <>
                    <br />
                    <strong>* Mohon diisi survey kepuasan: </strong>
                    <strong
                      style={{ color: "blue", cursor: "pointer" }}
                      onClick={() =>
                        window.open("https://bit.ly/KepuasanPelangganRSPG")
                      }
                    >
                      https://bit.ly/KepuasanPelangganRSPG
                    </strong>
                  </>
                )}
                {data?.namasbu === "RSPG Driyorejo" && (
                  <>
                    <br />
                    <strong>
                      * Mohon kirim kelengkapan berkas melalui Whatsapp ini:{" "}
                    </strong>
                    <strong
                      style={{ color: "blue", cursor: "pointer" }}
                      onClick={() => window.open("https://wa.me/6281235737711")}
                    >
                      Kirim Disini
                    </strong>
                  </>
                )}
              </span>
            </div>

            <br />

            <div className="d-grid gap-2">
              <Center>
                <ReactToPdf
                  targetRef={ref}
                  filename={data?.nobooking + ".pdf"}
                  options={options}
                  x={0.0}
                  y={0.0}
                  scale={0.9}
                >
                  {({ toPdf }) => (
                    <Button
                      variant="success"
                      onClick={toPdf}
                      style={{ width: "100%", maxWidth: "420px" }}
                    >
                      <Icons.FileText size={18} /> Download PDF
                    </Button>
                  )}
                </ReactToPdf>
              </Center>
            </div>
          </>
        </>
      )}
    </>
  );
}
